var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", { staticClass: "page-summary-card clickable" }, [
    _c(
      "div",
      { staticClass: "card-block", on: { click: _vm.openCardPreview } },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("p", { staticClass: "typography--body-3" }, [
              _c("strong", { staticClass: "typography--color-secondary" }, [
                _vm._v(_vm._s(_vm.index + 1))
              ]),
              _vm._v(" "),
              _vm.page.is_quiz
                ? _c(
                    "span",
                    { staticClass: "typography--color-disabled ml-1" },
                    [_vm._v(_vm._s(_vm.$t("common.card.quiz")))]
                  )
                : _c(
                    "span",
                    { staticClass: "typography--color-disabled ml-1" },
                    [_vm._v(_vm._s(_vm.$t("common.card.non_quiz")))]
                  )
            ]),
            _vm._v(" "),
            this.isPublisherUser
              ? _c(
                  "div",
                  {
                    style: {
                      background: _vm.getPageMetadataBackgroundColor,
                      cursor: "default"
                    }
                  },
                  [
                    _c("div", { staticClass: "ml-1" }, [
                      _vm._v(
                        "[페이지] - " +
                          _vm._s(this.page.id) +
                          " (" +
                          _vm._s(_vm.getPageShareLevelDescription) +
                          ")"
                      )
                    ]),
                    _vm._v(" "),
                    _vm.hasExtraContent
                      ? _c("div", { staticClass: "ml-1" }, [
                          _vm._v("* 긴지문 있음 *")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "ml-1" }, [
                      _vm._v(
                        "[핵심개념] - " +
                          _vm._s(this.page.core_concept_id) +
                          " (" +
                          _vm._s(_vm.getCoreConceptDescription) +
                          ")"
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "ml-1" }, [_vm._v("[키워드]")]),
                    _vm._v(" "),
                    _vm._l(_vm.getKeywords, function(keyword, index) {
                      return _c("div", { key: index }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(keyword.id + ": " + keyword.name) +
                            "\n          "
                        )
                      ])
                    })
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "page-content-container",
                class: _vm.classBindings
              },
              [
                _vm.hasExtraContent
                  ? _c("div", {
                      staticClass: "page-image-summary float-left",
                      style: { "background-image": _vm.extraContentImageSrc }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasImage
                  ? _c("div", {
                      staticClass: "page-image-summary float-left",
                      style: { "background-image": _vm.firstImageSrc }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasAudio
                  ? _c("div", { staticClass: "page-audio-summary" }, [
                      _c("img", {
                        staticClass: "align-middle",
                        attrs: { src: "/static/images/icon-audio.svg" }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "align-middle typography--body-3" },
                        [
                          _vm._v(
                            _vm._s(_vm._f("duration")(_vm.firstAudioDuration))
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasVideo || _vm.hasEmbededVideo
                  ? _c("div", { staticClass: "page-video-summary" }, [
                      _c("img", {
                        staticClass: "align-middle",
                        attrs: { src: "/static/images/icon-video.svg" }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "align-middle typography--body-3" },
                        [
                          _vm._v(
                            _vm._s(_vm._f("duration")(_vm.firstVideoDuration))
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "typography--body-2 typography--pre-line page-content",
                  domProps: { innerHTML: _vm._s(_vm.summarizedContent) }
                })
              ]
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "card-action" }, [
      _c(
        "div",
        { staticClass: "card-action-btn" },
        [
          _c(
            "IconDropdown",
            [
              _vm.isEditablePage
                ? _c(
                    "b-dropdown-item",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          return _vm.$emit("edit-page", _vm.index)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("common.card.page.edit")) +
                          "\n        "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-dropdown-item",
                {
                  staticClass: "dropdown-item",
                  on: {
                    click: function($event) {
                      return _vm.$emit("remove-page", _vm.index)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("common.card.page.remove")) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              this.isPublisherUser
                ? _c(
                    "div",
                    [
                      _c("div", { staticClass: "dropdown-divider" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "dropdown-label",
                          style: { "padding-left": "20px" }
                        },
                        [_c("strong", [_vm._v("관리자 메뉴")])]
                      ),
                      _vm._v(" "),
                      this.page.share_level !== 99
                        ? _c(
                            "b-dropdown-item",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function($event) {
                                  return _vm.$emit("hidden-page", _vm.index)
                                }
                              }
                            },
                            [_vm._v("\n            숨김\n          ")]
                          )
                        : _c(
                            "b-dropdown-item",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function($event) {
                                  return _vm.$emit(
                                    "recover-hidden-page",
                                    _vm.index
                                  )
                                }
                              }
                            },
                            [_vm._v("\n            숨김처리 복구\n          ")]
                          ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          staticClass: "dropdown-item",
                          on: {
                            click: function($event) {
                              return _vm.$emit("edit-extra-content", _vm.index)
                            }
                          }
                        },
                        [_vm._v("\n            긴지문 설정\n          ")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5538a1e8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5538a1e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/my-cards/components/MyPageSummary.vue
// module id = xJdW
// module chunks = 1